import React from "react";
import { useController } from "react-hook-form";
import classes from "./input.module.scss";
import classNames from "classnames";
import { Input as AntInput, Tooltip } from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons";

const Input = ({
  control,
  name,
  defaultValue,
  type = "text",
  className,
  children,
  ...props
}) => {
  const { field, fieldState } = useController({
    control,
    name,
    defaultValue,
  });

  const error = fieldState.error;

  return (
    <AntInput
      {...field}
      {...props}
      type={type}
      status={error ? "error" : ""}
      className={classNames(classes.Input, className)}
      suffix={
        error ? (
          <Tooltip title={error.message} color="#F29393">
            <FontAwesomeIcon icon={faExclamationCircle} className={classes.Error}/>
          </Tooltip>
        ) : null
      }
    />
  );
};

export default Input;
